<template>
  <div v-if="items.length > 0">
    <v-container fluid class="">
      <v-card>
        <v-card-title>Announcements</v-card-title>
        <v-card-text>
          <v-alert
            border="left"
            colored-border
            type="info"
            elevation="2"
            v-for="item in items"
            :key="item.id"
          >
            <div
              class="ql-editor"
              style="min-height: 10px"
              v-html="item.content"
            ></div>
          </v-alert>
        </v-card-text>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import formatterMixin from "@/mixins/formatterMixin";
import { mapState, mapActions } from "vuex";

export default {
  mixins: [formatterMixin],
  props: {
    clientId: Number,
    hideTitle: Boolean,
  },
  components: {},
  data: () => ({}),
  computed: {
    ...mapState({
      items: (state) => state.announcement.data,
    }),
  },
  watch: {
    clientId(n) {
      if (n) {
        this.filter.clientId = n;
      }
    },
  },

  async mounted() {
    await this.getAll({
      date: this.localToUtc(new Date()).format("YYYY-MM-DD HH:mm"),
    });
  },

  beforeDestroy() {},

  methods: {
    ...mapActions("announcement", ["getAll"]),
  },
};
</script>


<style lang="css">
@import "~vue2-editor/dist/vue2-editor.css";

/* Import the Quill styles you want */
@import "~quill/dist/quill.core.css";
@import "~quill/dist/quill.bubble.css";
@import "~quill/dist/quill.snow.css";
</style>